import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import LandingPage from "../../pages/Landing";
import NotFoundPage from "../../pages/NotFound/index";
import Register from "../../pages/Register/index";
import Login from "../../pages/Login";
import LoginAgain from"../../pages/Logout/loginAgain"
import ForgotPassword from "../../pages/ForgotPassword";
import EnterDigitCode from "../../pages/EnterDigitCode";
import ResetPasswoard from "../../pages/ResetPassowrd";
import VerificationPage from "../../pages/verificationPage";
import FAQPage from "../../pages/Faq";
import ContactPage from "../../pages/Contacts";

function PublicRoute() {
  return (
    <>
      <Routes>
        <Route path="/" exact element={<LandingPage />} />
        <Route path="/register" exact element={<Register />} />
        <Route path="*" exact element={<NotFoundPage />} />
        <Route path="/login" exact element={<Login />} />
        <Route path="/loginagain" exact element={<LoginAgain/>} />
        <Route path="/forgotpassword" exact element={<ForgotPassword/>} />
        <Route path="/code" exact element={<EnterDigitCode/>} />

        <Route path="/reset" exact element={<ResetPasswoard/>} />
        <Route path="/verify" exact element={<VerificationPage/>} />
        <Route path="/faqs" exact element={<FAQPage/>} />
        <Route path="/support" exact element={<ContactPage/>} />


 </Routes>
    </>
  );
}

export default PublicRoute;
